/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Flashcards Icon
 * @author Murhsid Ahamedh
 * @file FlashcardsIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@material-ui/core';

function FlashcardsIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4 1.5c1.2 0 2.3.6 2.9 1.4l5 .9c2 .3 3.4 2.2 3.1 4.2l-2.3 13.1c-.3 2-2.2 3.4-4.2 3.1l-8.3-1.4c-.5-.1-.9-.3-1.3-.6l-3 0c-2 0-3.7-1.6-3.7-3.6l-.1-13.2c0-2 1.6-3.6 3.6-3.6l8.4-.1zm3.7 17.1c0 1.3-.7 2.5-1.8 3.1l2.8.5c.9.1 1.7-.5 1.9-1.4l2.3-13.1c.1-.9-.5-1.7-1.4-1.9l-3.9-.7.1 13.5zM4 3.5c-.9 0-1.6.7-1.6 1.6l.1 13.2c0 .9.7 1.6 1.6 1.6l8.4-.1c.9 0 1.6-.7 1.6-1.6l-.1-13.2c0-.9-.7-1.6-1.6-1.6l-8.4.1zm6.6 7.4c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1l-4.7.2c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1l4.7-.2zm.4-3.6c.5 0 .9.4 .9.9s-.4.9-.9.9l-5.5.2c-.5 0-.9-.4-.9-.9s.4-.9.9-.9l5.5-.2z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default FlashcardsIcon;

